import { render, staticRenderFns } from "./InsightDisplayCarousel.vue?vue&type=template&id=48efcde4"
import script from "./InsightDisplayCarousel.vue?vue&type=script&lang=js"
export * from "./InsightDisplayCarousel.vue?vue&type=script&lang=js"
import style0 from "./InsightDisplayCarousel.vue?vue&type=style&index=0&id=48efcde4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports